export default "__VITE_ASSET__xBcLTiCL__"